/* function used to determine whether a dataviz should not be replaced by the tile 'No Data' if empty */
export function chartDisplaysNoData(vizType: string): boolean {
    if (vizType === 'gauge') return true;
    return false;
}
